import { store } from '@/store/index.js'
/*
 * vendor
 */
import VueBarcode from '@chenfengyuan/vue-barcode'
import { createHead, HeadVuePlugin } from '@vueuse/head'
import VueTouchEvents from 'vue3-touch-events'
import VueSocialSharing from 'vue-social-sharing'
import VueTour from 'vue3-tour'
import VueDOMPurifyHTML from 'vue-dompurify-html'

/*
 * our
 */
import Mapkit from './mapkit.js'
import Flash from './flash.js'
import Facebook from './facebook.js'
import e2eUtils from './e2e-utils.js'
import Datadog from './datadog/index.js'

export function registerPlugins ({ app, router }) {
  app.use(VueTouchEvents, {
    disableClick: true,
  })

  app.use(Datadog)

  app.component('vue-barcode', VueBarcode)

  app.use(Flash)

  app.use(Mapkit, store)

  app.use(VueSocialSharing)

  app.use(VueTour)

  app.use(Facebook)

  app.use(e2eUtils)

  app.use(VueDOMPurifyHTML, {
    default: {
      ADD_ATTR: ['target'],
    },
  })

  const head = createHead()
  app.use(HeadVuePlugin, head)
  app.use(head)
}
